import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../../../../CommonComponents/UIComponents/ToolTip/Tooltip';
import OverlayTrigger from '../../../../CommonComponents/UIComponents/OverlayTrigger/OverlayTrigger';
import './PackagesModal.scss';
import { pushDataLayerEvent } from '../../../../utils/DataLayer';
import Customevent from '../../../../utils/Customevent';
import Slider from 'react-slick';
import 'theme/vendor/slick.min.scss';
const settings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  adaptiveHeight: false,
  arrows: true,
  autoplay: false,
};

export default class PackagesModal extends Component {
  static propTypes = {
    showPackagesModal: PropTypes.bool,
    isLoader: PropTypes.bool,
    getLensPackagesFailed: PropTypes.object,
    LensPackage: PropTypes.object,
    productData: PropTypes.object,
    redisCommonData: PropTypes.object,
    addToCart: PropTypes.func,
  };
  constructor(props, context) {
    super(props, context);
    this.state = {
      isScroll: true,
      selectedLens: '',
    };
    // this.myRef = React.createRef();
  }
  componentDidMount() {
    const event = new Customevent('packageModelLoad');
    event.dispatch();
    if (typeof window.clevertap !== 'undefined') {
      window.clevertap.event.push('Page Visited', {
        pageName: 'Lens Package Page',
      });
    }
  }

  setSelectedLens = value => {
    this.setState({ selectedLens: value });
    if (window.dtm.LenskartRewamp)
      window.dtm.LenskartRewamp.Pdp.click.newGa('lensDescription', {
        lensType: value.subtitle || value.name,
      });
    const { addToCart } = this.props;
    addToCart(value);
    const dlUpdate = {};
    dlUpdate.event = 'selectLens';
    dlUpdate.selectLensSection = 'Prescription type';
    dlUpdate.selectLensOptionChosen = value.subtitle.replace(/\s+/g, ' ');
    pushDataLayerEvent(dlUpdate, true);
    // const e = document.getElementById('mySidenav');
    // if(e) {
    //     e.scrollHeight > e.clientHeight? this.myRef.current.scrollIntoView({ behavior: 'smooth' }) : null;
    // }
    // this.myRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  // package scroll on button click
  packageScrollBy = pos => {
    if (this.state.isScroll) {
      this.setState(
        {
          isScroll: false,
        },
        () => {
          document.getElementsByClassName('packages-list-scrollBar')[0].scrollBy({
            top: 0,
            left: pos,
            behavior: 'smooth',
          });
        }
      );
    }
  };

  modalOnEntered = () => {
    // package scroll and hide scoll btn
    const scrollElm = document.getElementsByClassName('packages-list-scrollBar')[0];
    if (scrollElm) {
      scrollElm.addEventListener('scroll', () => {
        this.packageScrollBy(290);
      });
    }
  };

  render() {
    const {
      isLoader,
      showPackagesModal,
      getLensPackagesFailed,
      LensPackage,
      productData,
      redisCommonData,
      dataLocale,
      exchangeBalance,
      isExchangeFlow,
      isExchange,
      exchangeText,
      exchangeFreeText,
      currencyMark,
    } = this.props;
    const { selectedLens } = this.state;
    const lensPackage = LensPackage.result;
    const specificationGroups = lensPackage.specificationGroups;
    const framePrice =
      productData.prices && productData?.prices.length === 3
        ? productData?.prices[2]?.price
        : productData?.prices[1]?.price;
    const blueCutLogo =
      redisCommonData && redisCommonData.BLUE_CUT_LOGO
        ? redisCommonData.BLUE_CUT_LOGO
        : 'https://static.lenskart.com/media/desktop/img/blu_logo.png';
    // sort packages through redis config
    if (redisCommonData && redisCommonData.SORT_PACKAGES_BY_PRICE_DESC === 'ON') {
      lensPackage.packages.sort((acd, dec) => {
        return dec.prices[1].price - acd.prices[1].price;
      });
    } else {
      // sort packages through api config
      lensPackage.packages.sort((acd, dec) => {
        return acd.sort_order - dec.sort_order;
      });
    }
    lensPackage.packages.forEach(packg => {
      const specificationListData = {};
      packg.specificationList.forEach(specification => {
        specificationListData[specification.group] = {
          title: specification.title,
          hoverImageUrl: specification.hoverImageUrl,
        };
      });
      packg.specificationListData = specificationListData;
    });

    const {
      FRAME_PLUS_LENS,
      TOLLTIP,
      OOPS_SOMETHING_WENT_WRONG,
      SELECTED,
      SELECT_LENS,
      INFO_IMG,
      INFO,
      ZERO,
      CURRENCY_CODE,
    } = dataLocale || {};
    const renderPackage = (currentPackage, index) => {
      let { displayPrice } = this.props;
      const headline = currentPackage.subtitle || currentPackage.name;
      const brandImg = currentPackage.brand_image_url;
      let exchangePrice = '';
      let exchangeBalancePrice;
      if (exchangeBalance && exchangeBalance.name) exchangeBalancePrice = exchangeBalance.price;
      else exchangeBalancePrice = exchangeBalance;
      displayPrice += currentPackage.prices[1].price;
      let itemExchangePrice = '';
      if (isExchange) {
        // const lenskartPrice = currentPackage.prices?.filter(p => p.name === 'Lenskart Price');
        exchangePrice = Math.round(displayPrice - exchangeBalancePrice);
        itemExchangePrice = currentPackage.prices.find(item => item.name === 'Item Exchange Price');
        // const returnedItemProps = sessionStorageHelper.getItem('returnedItemProps') || {};
        // const { modelName: model, packageId, packageGroup } = returnedItemProps;
        // if (exchangePrice > 0 && model === modelName && (packageGroup === pkg.group || packageId === pkg.id)) {
        //     exchangePrice = 0;
        // }
      }
      const isSelected = selectedLens && selectedLens.id === currentPackage.id;
      const isBluCut = headline && headline.toLowerCase()?.indexOf('blu') !== -1;
      const currencySymbol = currentPackage?.prices?.[1]?.currencyCode
        ? currencyMark?.[currentPackage?.prices?.[1]?.currencyCode]
        : currencyMark[CURRENCY_CODE];
      return (
        <div
          key={`package-${index}`}
          className={`package ${isSelected ? 'selected-package' : ''}`}
          style={{ width: isExchangeFlow ? 'auto' : '' }}
          onClick={() => this.setSelectedLens(currentPackage)}
        >
          <div className={isBluCut ? 'bluecut-logo' : 'normal-lens'}>
            {!isBluCut && <h2 className="title">{headline}</h2>}
            {isBluCut && (
              <h2 className="logo">
                <img alt={headline} src={blueCutLogo} title={headline} />
              </h2>
            )}
            {productData.type === 'Sunglasses' ? (
              <div className="brand-image">
                {brandImg && <img alt={headline} src={brandImg} title={headline} />}
              </div>
            ) : null}
            <div className={productData.type === 'Sunglasses' ? 'price-Sunglasses price' : 'price'}>
              {FRAME_PLUS_LENS}
              {isExchange && (
                <div className="text-dull_orange fsp14 fw600 exchange-text">
                  {currencySymbol}{' '}
                  {isExchange ? itemExchangePrice && itemExchangePrice.price : displayPrice}
                </div>
              )}
              {isExchange && (
                <div className="text-color-orange fsp14 fw600">
                  {currencySymbol}{' '}
                  {Number(exchangePrice) > 0 ? (
                    <span className="">{exchangePrice}</span>
                  ) : (
                    <span>{ZERO}</span>
                  )}
                </div>
              )}
              {isExchange && (
                <span className="exchange-price fs9 warranty text-color-orange text-uppercase inline-block bora-4 mr-t4">
                  {Number(exchangePrice) > 0 ? exchangeText : exchangeFreeText}
                </span>
              )}
              {!isExchange && (
                <strong>
                  {currencySymbol} {framePrice + currentPackage.prices[1].price}
                </strong>
              )}
            </div>
            <div className="warranty">{currentPackage.warranty}</div>
            <button
              className="btn btn-warning"
              style={{ backgroundColor: isSelected ? '#FAA61A' : '#00BAC6' }}
            >
              {isSelected ? SELECTED : SELECT_LENS}
            </button>
          </div>
          <ul className="specs-list">
            {currentPackage.recommendationLabel1 && (
              <li className="offer">{currentPackage.recommendationLabel1}</li>
            )}
            {specificationGroups.map((specification, index2) => {
              let title;
              let infoImage;
              if (currentPackage.specificationListData[specification]) {
                title = currentPackage.specificationListData[specification].title;
                infoImage = currentPackage.specificationListData[specification].hoverImageUrl;
              }
              return currentPackage.specificationListData[specification] ? (
                <li
                  key={`specification-${index2}`}
                  style={{ backgroundColor: index2 % 2 === 0 ? '#FFFFFF' : '#FAFAFA' }}
                >
                  {title}
                  {infoImage && (
                    <OverlayTrigger
                      overlay={
                        <Tooltip
                          className="package-info-details"
                          id="packageInfoDetails"
                          showArrow={false}
                          title={TOLLTIP}
                        >
                          <img alt={INFO_IMG} src={infoImage} />
                        </Tooltip>
                      }
                      placement="bottom"
                    >
                      <span className="package-info">
                        <img
                          alt={INFO}
                          src="https://static.lenskart.com/media/desktop/img/information-button.png"
                        />
                      </span>
                    </OverlayTrigger>
                  )}
                </li>
              ) : (
                <li
                  key={`specification-${index2}`}
                  style={{ backgroundColor: index2 % 2 === 0 ? '#FFFFFF' : '#FAFAFA' }}
                >
                  <span className="icon-cross"></span>
                </li>
              );
            })}
          </ul>
        </div>
      );
    };
    return (
      <div className="h-100vh-less150 overflow-y-auto margin-t150 margin-b90">
        <div className="extra-div">
          {isLoader && (
            <div className="packages-modal bg-color_white bora-4 pd-20 display-grid">
              <img
                alt="loading lens packages"
                className="package-loader"
                src="https://static.lenskart.com/media/mobile/images/img-loader.gif"
              />
            </div>
          )}
          {!isLoader && showPackagesModal && (
            <div className="packages-modal">
              <div className="modal-body">
                {getLensPackagesFailed || lensPackage.packages.length === 0 ? (
                  <section className="error-wrapper">
                    <div className="alert alert-danger">{OOPS_SOMETHING_WENT_WRONG}</div>
                  </section>
                ) : (
                  <section
                    className={
                      productData.type === 'Sunglasses'
                        ? 'packages-list sunglasses'
                        : 'packages-list'
                    }
                  >
                    {lensPackage.packages.length > 2 ? (
                      <div
                        className="slider-main slider-custom package-lens-button"
                        style={{ width: '100%' }}
                      >
                        <Slider {...settings}>
                          {lensPackage.packages.map((currentPackage, index) => {
                            return (
                              <div key={index} className="padding-l5 padding-r5">
                                {renderPackage(currentPackage, index)}
                              </div>
                            );
                          })}
                        </Slider>
                      </div>
                    ) : (
                      <div
                        className="display-flex justify-content-center"
                        style={{ width: '100%' }}
                      >
                        {lensPackage.packages.map((currentPackage, index) => {
                          return (
                            <div key={index} className="padding-l5 padding-r5">
                              {renderPackage(currentPackage, index)}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </section>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
